import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 transition-smooth hover-lift">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="GraduationCap" size={24} color="var(--color-primary)" />
            </div>
            <div>
              <span className="text-xl font-heading font-semibold text-foreground block">Studyexpo</span>
              <span className="text-xs text-muted-foreground">Virtual Education Fair</span>
            </div>
          </Link>

          <div className="flex items-center gap-3">
            <Link 
              to="/institute-login"
              className="px-4 py-2 text-sm font-medium text-primary hover:bg-primary/10 rounded-lg transition-smooth inline-block"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationHeader;